import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { ParticipantTypeEnum } from '../_shared/models/csTypes/enums/participant_type';

@Injectable({
  providedIn: 'root'
})
export class ParticipantListService {
  private httpClient = inject(HttpClient);

  constructor() { }

  getTournamentParticipants(participantType, _tournamentId) {
    return this.httpClient.get<any>('api_endpoint' + `/participant/tournament/${_tournamentId}/${participantType}`).pipe(
      map(res => res.data?.participants)
    );
  }

  create(users: {first_name: string, last_name: string}[], participantType: ParticipantTypeEnum, _tournamentId: string) {
    return this.httpClient.post<any>('api_endpoint' + `/participant/create`, { users, participantType, _tournamentId }).pipe(
      map(res => res.data)
    );
  }

  delete(_participantId) {
    return this.httpClient.post<any>('api_endpoint' + `/participant/delete`, { _participantId }).pipe(
      map(res => res.data)
    );
  }
}
